// Cover-fits the (optionally cropped) image into box, then applies zoom + offset.
export const PlacedImage = ({ placement, box, href }) => {
  const { file, crop, zoom = 1, x = 0, y = 0 } = placement;
  if (!file || !href) return null;
  const cx = crop ? (crop.x / 100) * file.w : 0;
  const cy = crop ? (crop.y / 100) * file.h : 0;
  const cw = crop ? (crop.width / 100) * file.w : file.w;
  const ch = crop ? (crop.height / 100) * file.h : file.h;
  const s = Math.max(box.w / cw, box.h / ch) * zoom;
  const dw = cw * s, dh = ch * s;
  return (
    <svg x={box.x + (box.w - dw) / 2 + x} y={box.y + (box.h - dh) / 2 + y} width={dw} height={dh}
      viewBox={`${cx} ${cy} ${cw} ${ch}`} preserveAspectRatio="none" overflow="hidden">
      <image href={href} width={file.w} height={file.h} preserveAspectRatio="none" />
    </svg>
  );
};
